module.exports = __webpack_public_path__ + "static/media/7.eb220652.jpg";